/*=========================================================================================
  File Name: betState.js
  Description: bet Module State
==========================================================================================*/

export default {

    code: '',
    roomno: '',
    roomorder: '',
    bettings: [
        {
            betpos: '',
            amount: 0
        }
    ],
    prevbettings: [
        {
            betpos: '',
            amount: 0
        }
    ],
    notifications: {
        show: false,
        message: ''
    },
    totbetamt: 0,
    prevtotbetamt: 0
}